import React from "react";

import { Box, Chip, Typography } from "@mui/material";

import { PrimaryLanguage } from "../../types";

import { LANGUAGE_LABEL } from "./template-gallery-constants";

interface TemplateLanguageFilterProps {
  languageFilter: PrimaryLanguage | null;
  onChange: (language: PrimaryLanguage | null) => void;
}

export function TemplateLanguageFilter({
  languageFilter,
  onChange,
}: TemplateLanguageFilterProps) {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="caption" color="text.secondary" sx={{ mr: 1 }}>
        Filter by language:
      </Typography>
      <Chip
        label="All"
        size="small"
        variant={languageFilter === null ? "filled" : "outlined"}
        onClick={() => onChange(null)}
        sx={{ mr: 0.5 }}
      />
      {Object.values(LANGUAGE_LABEL).map((lang) => (
        <Chip
          key={lang}
          label={lang}
          size="small"
          variant={
            languageFilter && LANGUAGE_LABEL[languageFilter] === lang
              ? "filled"
              : "outlined"
          }
          onClick={() => {
            const langKey = Object.entries(LANGUAGE_LABEL).find(
              ([, v]) => v === lang,
            )?.[0] as PrimaryLanguage | undefined;
            onChange(langKey || null);
          }}
          sx={{ mr: 0.5 }}
        />
      ))}
    </Box>
  );
}
